import { render, staticRenderFns } from "./strategy-card.component.vue?vue&type=template&id=63ccc04b&scoped=true"
import script from "./strategy-card.component.vue?vue&type=script&lang=js"
export * from "./strategy-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ccc04b",
  null
  
)

export default component.exports